module.exports = __webpack_public_path__ + "is.1eecf71d.svg";